import React, {useContext, useRef, useState} from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Checkbox,
  Chip,
  Switch,
  TextField,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import {useQueryUniqueUsers} from "../../../queries/pharmacy/hooks/useQueryUniqueUsers";
import {UserContext} from "../../../hooks/userContext";
import {useQueryPharmacyOptions} from "../../../queries/pharmacy/hooks/useQueryPharmacyOptions";
import {useQueryUniquePharmacy} from "../../../queries/pharmacy/hooks/useQueryUniquePharmacy";
import {useNavigate, useParams} from "react-router-dom";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import PharmacyDetailsItem from "./PharmacyDetailsItem";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {IPharmacyType, IStatement} from "../../../queries/pharmacy/pharmacyModel";
import {ToasterContext} from "../../../components/shared/Toaster/ToasterContext";
import {Controller, useForm} from "react-hook-form";
import Box from "@mui/material/Box";
import {NotificationType, SERVER_URL} from "../../../constants/global";
import {useMutationUpdatePharmacy} from "../../../queries/pharmacy/hooks/useMutationUpdatePharmacy";
import {useMutationUpdateSellingLimitations} from "../../../queries/pharmacy/hooks/useMutationUpdateSellingLimitations";
import {useMutationUpdateBuyingLimitations} from "../../../queries/pharmacy/hooks/useMutationUpdateBuyingLimitations";
import {useMutation, useQuery} from "@apollo/client";
import {TOGGLE_CARD_PAYMENT, PHARMACY_SELECT_OPTIONS} from "../../../queries/pharmacy/pharmacyTypeDefs";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import {useQueryStatuses} from "../../../queries/pharmacy/hooks/useQueryStatuses";
import {useQueryPharmacyUsers} from "../../../queries/pharmacy/hooks/useQueryPharmacyUsers";
import {useQuerySellingLimitations} from "../../../queries/pharmacy/hooks/useQuerySellingLimitations";
import {useQueryBuyingLimitations} from "../../../queries/pharmacy/hooks/useQueryBuyingLimitations";
import {useQueryWantedItems} from "../../../queries/wantedItem/hooks/useQueryWantedItems";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {updatePharmacyValidationSchema} from "../../../constants/validationSchemas";
import {PHARMACIES, PHARMACIES_LIST_ORDER_BY} from "../../../queries/pharmacy/pharmacyTypeDefs";
import {routeConfigs} from "../../../navigation/routeConfig";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import LocalSeeOutlinedIcon from '@mui/icons-material/LocalSeeOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EditOffOutlinedIcon from "@mui/icons-material/EditOffOutlined";
import {green, grey} from "@mui/material/colors";
import Link from "@mui/material/Link";
import moment from "moment";
import Divider from "@mui/material/Divider";
import {useAuth} from "../../../hooks/useAuth";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PharmacyDetails from "../../PharmacyProfile/PharmacyDetails";
import PhysicalAddress from "../../PharmacyProfile/PhysicalAddress";
import OtherDetails from "../../PharmacyProfile/OtherDetails";
import {additionalQuestions} from "../../../constants/signupQuestions";
import axios from "axios";

const Pharmacy:React.FunctionComponent = () => {
  const { id: pharmacyId } = useParams<any>();
  const { id }: any = useContext(UserContext);
  const {addToast} = useContext(ToasterContext);
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors }, control, setValue, getValues } = useForm({
    resolver: yupResolver(updatePharmacyValidationSchema)
  });
  const [ resetLoading, setResetLoading ] = useState<number|null>(null);
  const [ openResetPassword, setResetPassword ] = useState<any|null>(null);
  const [ editPharmacyDetails, setEditPharmacyDetails ] = useState<boolean>(false);
  const [ editPhysicalAddress, setEditPhysicalAddress ] = useState<boolean>(false);
  const [ editOtherDetails, setEditOtherDetails ] = useState<boolean>(false);
  const [sellingLimitationsBlockAll, setSellingLimitationsBlockAll] = useState<boolean>(false);
  const [sellingLimitedNdcs, setSellingLimitedNdcs] = useState<any[]>([]);
  const [sellingLimitedManufacturers, setSellingLimitedManufacturers] = useState<any[]>([]);
  const [ndcSearchOptions, setNdcSearchOptions] = useState<any[]>([]);
  const [manufacturerSearchOptions, setManufacturerSearchOptions] = useState<any[]>([]);
  const [sellingLimitationSearchLoading, setSellingLimitationSearchLoading] = useState<boolean>(false);
  const [sellingLimitationsSaving, setSellingLimitationsSaving] = useState<boolean>(false);
  const [confirmSellingLimitationsOpen, setConfirmSellingLimitationsOpen] = useState<boolean>(false);
  const [buyingAllowedSellers, setBuyingAllowedSellers] = useState<any[]>([]);
  const [buyingLimitationsSaving, setBuyingLimitationsSaving] = useState<boolean>(false);
  const [confirmCardDisableOpen, setConfirmCardDisableOpen] = useState<boolean>(false);
  const ndcSearchAbortRef = useRef<AbortController | null>(null);
  const manufacturerSearchAbortRef = useRef<AbortController | null>(null);
  const hydrateAbortRef = useRef<AbortController | null>(null);
  const ndcSearchRequestIdRef = useRef(0);
  const manufacturerSearchRequestIdRef = useRef(0);
  const { token } = useAuth();

  const {data: pharmacyUsersData, loading: pharmacyUsersLoading } = useQueryUniqueUsers({
    variables: { where: { id:  +id } },
  });
  const {data: pharmacyOptionData, loading: pharmacyOptionsLoading} = useQueryPharmacyOptions({});
  const {data: pharmacyData, loading: pharmacyLoading, refetch } = useQueryUniquePharmacy({
    variables: { where: { id: Number(pharmacyId) } },
    skip: !pharmacyUsersData,
    fetchPolicy: 'no-cache'
  });
  const {data: statusData, loading: statusLoading} = useQueryStatuses();
  const {data: pharmacyUsers, loading: usersLoading} = useQueryPharmacyUsers({
    variables: {
      where: { Pharmacy: { is: { id: { equals: Number(pharmacyId) } } } },
      orderBy: [ { createdAt: "asc" } ]
    },
    fetchPolicy: 'network-only'
  });
  const {data: wantedItemsData, loading: wantedItemsLoading} = useQueryWantedItems({
    fetchPolicy: 'no-cache'
  });
  const {data: sellingLimitationsData, loading: sellingLimitationsLoading, refetch: refetchSellingLimitations} = useQuerySellingLimitations({
    variables: { pharmacyId: Number(pharmacyId) },
    skip: !pharmacyId,
    fetchPolicy: "no-cache",
  });
  const {data: buyingLimitationsData, loading: buyingLimitationsLoading, refetch: refetchBuyingLimitations} = useQueryBuyingLimitations({
    variables: { pharmacyId: Number(pharmacyId) },
    skip: !pharmacyId,
    fetchPolicy: "no-cache",
  });
  const {data: pharmacySelectData, loading: pharmacySelectLoading} = useQuery(PHARMACY_SELECT_OPTIONS, {
    fetchPolicy: "no-cache",
  });

  const normalizeNdc = (value: string) => {
    return (value || "").replace(/\D/g, "");
  };

  const formatNdc = (value: string) => {
    const clean = normalizeNdc(value);
    if (clean.length === 11) {
      return `${clean.slice(0, 5)}-${clean.slice(5, 9)}-${clean.slice(9)}`;
    }
    if (clean.length === 10) {
      return `${clean.slice(0, 4)}-${clean.slice(4, 8)}-${clean.slice(8)}`;
    }
    return value || clean;
  };

  const normalizeManufacturer = (value: string) => {
    return (value || "").trim().toLowerCase();
  };

  const LEGACY_GLP1_NDCS = [
    "00169413001","00169413013","00169413211","00169413212","00169413602","00169413611","00169418113","00169477211","00169477212",
    "50090594900","50090605100","00169450114","00169450514","00169451714","00169452414","00169452514","50090582400","00169406012",
    "00169406013","50090285300","50090450300","00169280015","50090425700","00002143301","00002143380","00002143401","00002143480",
    "00002223601","00002223680","00002318201","00002318280","50090348300","50090348400","50090546700","50090645300","50090645600",
    "50090657100","50090758900","00310651201","00310652401","00310654001","00310654004","00002145701","00002145780","00002146001",
    "00002146080","00002147101","00002147180","00002148401","00002148480","00002149501","00002149580","00002150601","00002150680",
    "00002015204","00002024304","00002121404","00002134004","00002142301","00002142304","00002200201","00002200204","00002245701",
    "00002245780","00002246001","00002246080","00002247101","00002247180","00002248401","00002248480","00002249501","00002249580",
    "00002250601","00002250680",
  ];

  const capitalizeWords = (str: string) => {
    if (!str) {
      return str;
    }
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const buildNdcOption = (item: any) => {
    const normalizedNdc = normalizeNdc(item?.product_ndc || item?.ndc || "");
    const formattedNdc = formatNdc(normalizedNdc);
    const drugName = capitalizeWords(
      (item?.brand_name || item?.generic_name || "").trim()
    );
    const labeler = item?.labeler_name
      ? ` (${capitalizeWords(item.labeler_name.trim())})`
      : "";
    return {
      ndc: normalizedNdc,
      manufacturer: normalizeManufacturer(item?.labeler_name || ""),
      label: drugName
        ? `${drugName} - ${formattedNdc}${labeler}`
        : formattedNdc,
      raw: item,
    };
  };

  React.useEffect(() => {
    const limitation = sellingLimitationsData?.sellingLimitations;
    if (!limitation) {
      return;
    }

    setSellingLimitationsBlockAll(Boolean(limitation.blockAllPostings));
    const savedNdcs = (limitation.ndcs || [])
      .map((ndc: string) => normalizeNdc(ndc))
      .filter(Boolean);
    setSellingLimitedNdcs(
      savedNdcs.map((ndc: string) => ({
        ndc,
        label: formatNdc(ndc),
      }))
    );
    setSellingLimitedManufacturers(
      (limitation.restrictedManufacturers || []).map((m: string) => ({
        manufacturer: m,
        label: capitalizeWords(m),
      }))
    );

    let cancelled = false;
    if (hydrateAbortRef.current) {
      hydrateAbortRef.current.abort();
    }
    const hydrateAbortController = new AbortController();
    hydrateAbortRef.current = hydrateAbortController;
    const hydrateNdcLabels = async () => {
      if (!savedNdcs.length) {
        return;
      }

      try {
        const hydrated: any[] = [];
        // Run sequentially to prevent large parallel bursts when many NDCs are saved.
        for (const ndc of savedNdcs) {
          const api = `${process.env.REACT_APP_API_URL}/medispan/get?searchTerm=${encodeURIComponent(ndc)}`;
          const response = await axios.get(api, {
            signal: hydrateAbortController.signal,
          });
          const rows = parseMedispanRows(response.data);
          const exact = rows.find(
            (row: any) => normalizeNdc(row?.product_ndc) === normalizeNdc(ndc)
          );
          if (!exact) {
            hydrated.push({ ndc, label: formatNdc(ndc) });
          } else {
            hydrated.push(buildNdcOption(exact));
          }
        }

        if (!cancelled) {
          setSellingLimitedNdcs(hydrated);
        }
      } catch (error) {
        if (isAbortError(error)) {
          return;
        }
        // keep fallback labels if hydration fails
      }
    };

    hydrateNdcLabels();
    return () => {
      cancelled = true;
      hydrateAbortController.abort();
    };
  }, [sellingLimitationsData]);

  const parseMedispanRows = (data: unknown) =>
    Array.isArray(data)
      ? data.filter((item: any) => item?.product_ndc)
      : [];

  const isAbortError = (error: any) =>
    error?.name === "CanceledError" ||
    error?.name === "AbortError" ||
    error?.code === "ERR_CANCELED";

  const handleSellingLimitationNdcSearch = async (value: string) => {
    const term = value.trim();
    if (term.length < 3) {
      if (ndcSearchAbortRef.current) {
        ndcSearchAbortRef.current.abort();
      }
      setNdcSearchOptions([]);
      return;
    }

    if (ndcSearchAbortRef.current) {
      ndcSearchAbortRef.current.abort();
    }
    const abortController = new AbortController();
    ndcSearchAbortRef.current = abortController;
    const requestId = ++ndcSearchRequestIdRef.current;

    setSellingLimitationSearchLoading(true);
    try {
      const api = `${process.env.REACT_APP_API_URL}/medispan/get?searchTerm=${encodeURIComponent(term)}`;
      const response = await axios.get(api, { signal: abortController.signal });
      if (requestId !== ndcSearchRequestIdRef.current) {
        return;
      }
      const rows = parseMedispanRows(response.data);
      const normalizedTerm = normalizeNdc(term);
      const isExactNdcQuery =
        normalizedTerm.length === 10 || normalizedTerm.length === 11;

      const filteredRows = isExactNdcQuery
        ? rows.filter(
            (item: any) => normalizeNdc(item?.product_ndc) === normalizedTerm
          )
        : rows;

      const ndcOptions = filteredRows
        .map((item: any) => buildNdcOption(item))
        .filter((item: any) => item.ndc);
      setNdcSearchOptions(ndcOptions);
    } catch (error: any) {
      if (isAbortError(error)) {
        return;
      }
      addToast({
        type: NotificationType.Error,
        title: error.message || "Failed to fetch Medi-Span results",
      });
    } finally {
      if (requestId === ndcSearchRequestIdRef.current) {
        setSellingLimitationSearchLoading(false);
      }
    }
  };

  const handleSellingLimitationManufacturerSearch = async (value: string) => {
    const term = value.trim();
    if (term.length < 3) {
      if (manufacturerSearchAbortRef.current) {
        manufacturerSearchAbortRef.current.abort();
      }
      setManufacturerSearchOptions([]);
      return;
    }

    if (manufacturerSearchAbortRef.current) {
      manufacturerSearchAbortRef.current.abort();
    }
    const abortController = new AbortController();
    manufacturerSearchAbortRef.current = abortController;
    const requestId = ++manufacturerSearchRequestIdRef.current;

    setSellingLimitationSearchLoading(true);
    try {
      const api = `${process.env.REACT_APP_API_URL}/medispan/manufacturers?searchTerm=${encodeURIComponent(term)}`;
      const response = await axios.get(api, { signal: abortController.signal });
      if (requestId !== manufacturerSearchRequestIdRef.current) {
        return;
      }
      const rows = Array.isArray(response.data) ? response.data : [];
      const options = rows
        .map((item: any) => {
          const key = normalizeManufacturer(item?.manufacturer || "");
          const displayRaw = (item?.label || item?.manufacturer || "").trim();
          if (!key || !displayRaw) {
            return null;
          }
          return {
            manufacturer: key,
            label: capitalizeWords(displayRaw),
          };
        })
        .filter(Boolean);
      setManufacturerSearchOptions(options as any[]);
    } catch (error: any) {
      if (isAbortError(error)) {
        return;
      }
      addToast({
        type: NotificationType.Error,
        title: error.message || "Failed to fetch Medi-Span results",
      });
    } finally {
      if (requestId === manufacturerSearchRequestIdRef.current) {
        setSellingLimitationSearchLoading(false);
      }
    }
  };

  const debouncedSellingLimitationNdcSearch = React.useMemo(() => {
    return ((fn: (value: string) => void) => {
      const timeoutRef: { current: any } = { current: null };
      return (value: string) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => fn(value), 400);
      };
    })(handleSellingLimitationNdcSearch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const debouncedSellingLimitationManufacturerSearch = React.useMemo(() => {
    return ((fn: (value: string) => void) => {
      const timeoutRef: { current: any } = { current: null };
      return (value: string) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => fn(value), 400);
      };
    })(handleSellingLimitationManufacturerSearch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const limitation = buyingLimitationsData?.buyingLimitations;
    const pharmacies = pharmacySelectData?.findManyPharmacy;
    if (!limitation || !pharmacies) {
      return;
    }

    const pharmacyById = new Map(
      pharmacies.map((pharmacy: any) => [Number(pharmacy.id), pharmacy])
    );
    setBuyingAllowedSellers(
      (limitation.allowedSellerPharmacyIds || []).map(
        (sellerId: number) =>
          pharmacyById.get(Number(sellerId)) || {
            id: sellerId,
            legalName: `Pharmacy #${sellerId}`,
            email: '',
          }
      )
    );
  }, [buyingLimitationsData, pharmacySelectData]);

  const buyingAllowedSellerOptions = (pharmacySelectData?.findManyPharmacy || []).filter(
    (pharmacy: any) => Number(pharmacy.id) !== Number(pharmacyId)
  );
  const isBuyingLimitationsActive =
    (buyingLimitationsData?.buyingLimitations?.allowedSellerPharmacyIds?.length || 0) > 0;

  const handleSaveBuyingLimitations = async () => {
    setBuyingLimitationsSaving(true);
    try {
      await updateBuyingLimitations({
        variables: {
          pharmacyId: Number(pharmacyId),
          allowedSellerPharmacyIds: buyingAllowedSellers.map((pharmacy: any) =>
            Number(pharmacy.id)
          ),
        },
      });
      await refetchBuyingLimitations();
      addToast({
        type: NotificationType.Success,
        title: "Buying Limitations saved.",
      });
    } catch (error: any) {
      addToast({
        type: NotificationType.Error,
        title: error.message || "Failed to save Buying Limitations",
      });
    } finally {
      setBuyingLimitationsSaving(false);
    }
  };

  const savedSellingLimitations = sellingLimitationsData?.sellingLimitations;
  const isSellingLimitationsActive =
    Boolean(savedSellingLimitations?.blockAllPostings) ||
    (savedSellingLimitations?.ndcs?.length || 0) > 0 ||
    (savedSellingLimitations?.restrictedManufacturers?.length || 0) > 0;

  const handleRequestSaveSellingLimitations = () => {
    setConfirmSellingLimitationsOpen(true);
  };

  const handleAddLegacyGlp1Ndcs = () => {
    const existing = new Set(
      sellingLimitedNdcs
        .map((item: any) => normalizeNdc(item.ndc))
        .filter(Boolean)
    );

    const newItems = LEGACY_GLP1_NDCS
      .map((ndc) => normalizeNdc(ndc))
      .filter((ndc) => ndc && !existing.has(ndc))
      .map((ndc) => ({
        ndc,
        label: formatNdc(ndc),
      }));

    if (!newItems.length) {
      addToast({
        type: NotificationType.Success,
        title: "GLP-1 NDCs are already in Restricted NDCs",
      });
      return;
    }

    setSellingLimitedNdcs([...sellingLimitedNdcs, ...newItems]);
    addToast({
      type: NotificationType.Success,
      title: `Added ${newItems.length} GLP-1 NDCs to Restricted NDCs`,
    });
  };

  const handleCancelSaveSellingLimitations = () => {
    setConfirmSellingLimitationsOpen(false);
  };

  const handleConfirmSaveSellingLimitations = async () => {
    setConfirmSellingLimitationsOpen(false);
    setSellingLimitationsSaving(true);
    try {
      const ndcs = Array.from(
        new Set(
          sellingLimitedNdcs
            .map((item: any) => normalizeNdc(item.ndc))
            .filter(Boolean)
        )
      );
      const restrictedManufacturers = Array.from(
        new Set(
          sellingLimitedManufacturers
            .map((item: any) => normalizeManufacturer(item.manufacturer))
            .filter(Boolean)
        )
      );

      const response = await updateSellingLimitations({
        variables: {
          pharmacyId: Number(pharmacyId),
          blockAllPostings: sellingLimitationsBlockAll,
          ndcs,
          restrictedManufacturers,
        },
      });

      const deactivatedCount =
        response?.data?.updateSellingLimitations?.deactivatedCount ?? 0;
      await refetchSellingLimitations();
      addToast({
        type: NotificationType.Success,
        title: `Selling Limitations saved. ${deactivatedCount} existing posting(s) deactivated.`,
      });
    } catch (error: any) {
      addToast({
        type: NotificationType.Error,
        title: error.message || "Failed to save Selling Limitations",
      });
    } finally {
      setSellingLimitationsSaving(false);
    }
  };
  const [updatePharmacy, { loading }] = useMutationUpdatePharmacy({
    refetchQueries: [
      { query: PHARMACIES, variables: { orderBy: PHARMACIES_LIST_ORDER_BY } },
    ],
  });
  const [updateSellingLimitations] = useMutationUpdateSellingLimitations();
  const [updateBuyingLimitations] = useMutationUpdateBuyingLimitations();
  const [toggleCardPayment] = useMutation(TOGGLE_CARD_PAYMENT);
  const [cardToggleLoading, setCardToggleLoading] = useState<boolean>(false);

  const handleCardPaymentToggle = (enabled: boolean) => {
    if (!enabled) {
      setConfirmCardDisableOpen(true);
      return;
    }
    setCardToggleLoading(true);
    toggleCardPayment({
      variables: { pharmacyId: Number(pharmacyId), enabled: true },
    }).then(() => {
      addToast({ type: NotificationType.Success, title: 'Card payment enabled for this pharmacy.' });
      return refetch();
    }).catch((err: any) => {
      addToast({ type: NotificationType.Error, title: err.message });
    }).finally(() => {
      setCardToggleLoading(false);
    });
  };

  const confirmDisableCardPayment = () => {
    setConfirmCardDisableOpen(false);
    setCardToggleLoading(true);
    toggleCardPayment({
      variables: { pharmacyId: Number(pharmacyId), enabled: false },
    }).then(() => {
      addToast({ type: NotificationType.Success, title: 'Card payment disabled for this pharmacy.' });
      return refetch();
    }).catch((err: any) => {
      addToast({ type: NotificationType.Error, title: err.message });
    }).finally(() => {
      setCardToggleLoading(false);
    });
  };

  const isLicenseExpired = (deaLicenseDate: any, ncpdpLicenseDate: any) => {
    if (!ncpdpLicenseDate || !deaLicenseDate) {
      return false;
    }

    return !moment().isSameOrBefore(deaLicenseDate.format('YYYY-MM-DD'), 'd')
      || !moment().isSameOrBefore(ncpdpLicenseDate.format('YYYY-MM-DD'), 'd');
  }

  const filteredStatements = () => {
    return pharmacyData.findUniquePharmacy.PharmacyStatement.map((statement: IStatement) => {
      return {
        id: statement.id,
        question: statement.Statement.question,
        answer: statement.answer ? 'YES' : 'NO'
      }
    })
  };

  const getOption = (options: any, id: number) => {
    const option: any = options.find((state: any) => state.id === id);

    return {
      label: option.name,
      value: option.id
    }
  }

  const handleUpdatePharmacy = async (values: any) => {
    const requestData = {
      PharmacyStatus: {
        update: {
          Status: {
            connect: {
              id: +values.status
            }
          },
        }
      },
      PharmacyLicenses: {
        create: {
          deaLicenseDate: new Date(values.deaLicenseDate),
          ncpdpLicenseDate: new Date(values.ncpdpLicenseDate),
          User: {
            connect: {
              id: +id
            }
          }
        }
      }
    }

    updatePharmacy({ variables: { data: requestData, where: { id: Number(pharmacyId) } } }).then(() => {
      addToast({ type: NotificationType.Success, title: 'Pharmacy successfully updated' });
      navigate(routeConfigs.pharmacies.path);
    }).catch((error: any) => {
      addToast({ type: NotificationType.Error, title: error.message  });
    });
  }

  const resetPassword = async (userId: number, userName: string) => {
    setResetLoading(userId)
    try {
      const response: any = await fetch(`${SERVER_URL}/users/reset-password`, {
        method: 'POST',
        body: JSON.stringify({ 'userId': userId }),
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const data = await response.json();
        setResetPassword({
          userName: userName,
          password: data.password
        })
      }
      setResetLoading(null)
    } catch (error: any) {
      setResetLoading(null)
    }
  }

  const getBankAccount = (bankAccounts: any) => {
    return bankAccounts.find((item: any)=>item.object === 'bank_account');
  }

  const getBuyerAchAccount = (bankAccounts: any) => {
    return bankAccounts.find(
      (item: any) => item.object === 'payment_method' && item.last4
    );
  }

  const getBuyerCardAccount = (bankAccounts: any) => {
    return bankAccounts.find(
      (item: any) => item.object === 'card' && item.last4
    );
  }

  const getPaymentAccountStatusChip = (status?: string) => {
    const key = (status || '').toUpperCase();
    if (key === 'VERIFIED' || key === 'APPROVED') {
      return { label: status || 'Verified', color: 'success' as const };
    }
    if (key === 'PENDING' || key === 'NEW') {
      return { label: status || 'Pending', color: 'warning' as const };
    }
    if (status) {
      return { label: status, color: 'default' as const };
    }
    return null;
  }

  const getPharmacyFiles = (files: any, type: string = 'license') => {
    if (type === 'license') {
      return files.filter((pharmacyFile: any) => pharmacyFile.File.type === 'deaLicense' || pharmacyFile.File.type === 'ncpdpLicense')
    }

    if (type === 'bank') {
      return files.filter((pharmacyFile: any) => pharmacyFile.File.type === 'irs147CLetter')
    }

    return files
  }

  const pharmacyUsersList = pharmacyUsers?.findManyPharmacyUsers || [];
  const pharmacyUserIds = new Set(pharmacyUsersList.map((user: any) => user.User.id));
  const userById = new Map<number, string>(
    pharmacyUsersList.map((user: any) => [
      user.User.id,
      `${user.User.firstName} ${user.User.lastName}`,
    ])
  );
  const pharmacyWishlistItems = (wantedItemsData?.findManyWantedItem || []).filter(
    (item: any) => pharmacyUserIds.has(item.buyerUserId)
  );

  if (pharmacyUsersLoading || pharmacyLoading || pharmacyOptionsLoading || statusLoading || usersLoading || wantedItemsLoading || sellingLimitationsLoading || buyingLimitationsLoading || pharmacySelectLoading) {
    return <CircularProgress sx={{position: 'absolute', left: 'calc(150px + 50%)', top: '50%'}} color="inherit" />
  }

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h1" variant="h5">Pharmacy Details</Typography>
          { editPharmacyDetails ?
            <EditOffOutlinedIcon
              sx={{ ml: 1, cursor: 'pointer', color: grey[500] }}
              onClick={(event: any) => {
                event.stopPropagation();
                setEditPharmacyDetails(false);
              }}
            />
            :
            <EditOutlinedIcon
              sx={{ ml: 1, cursor: 'pointer', color: green[500] }}
              onClick={(event) => {
                event.stopPropagation();
                setEditPharmacyDetails(true);
              }}
            />
          }
        </AccordionSummary>
        <AccordionDetails>
          { editPharmacyDetails ?
            <PharmacyDetails
              data={pharmacyData.findUniquePharmacy}
              states={pharmacyOptionData.findManyState}
              pharmacyId={Number(pharmacyId)}
              isAdminEdit={true}
              refetchPharmacy={refetch}
            />
            :
            <Grid container spacing={2}>
              <PharmacyDetailsItem label='Legal Name:' value={pharmacyData.findUniquePharmacy.legalName} />
              <PharmacyDetailsItem label='Pharmacy NCPDP:' value={pharmacyData.findUniquePharmacy.ncpdp} />
              <PharmacyDetailsItem label='Pharmacy NPI:' value={pharmacyData.findUniquePharmacy.npi} />
              <PharmacyDetailsItem label='DEA Number:' value={pharmacyData.findUniquePharmacy.deaNumber} />
              <PharmacyDetailsItem
                label='Pharmacy License:'
                value={getOption(pharmacyOptionData.findManyState, pharmacyData.findUniquePharmacy.PharmacyLicensedStates.State.id).label}
              />
              <PharmacyDetailsItem label='Federal Tax ID:' value={pharmacyData.findUniquePharmacy.federalTaxId} />
              <PharmacyDetailsItem label='Software Name:' value={pharmacyData.findUniquePharmacy.softwareName} />
              <PharmacyDetailsItem label='Email Address:' value={pharmacyData.findUniquePharmacy.email} />
              <PharmacyDetailsItem label='Phone:' value={pharmacyData.findUniquePharmacy.phone} />
              <PharmacyDetailsItem label='Mobile:' value={pharmacyData.findUniquePharmacy.mobile} />
              <PharmacyDetailsItem label='Fax:' value={pharmacyData.findUniquePharmacy.fax} />
              <PharmacyDetailsItem label='Website:' value={pharmacyData.findUniquePharmacy.site} />
              <PharmacyDetailsItem label='Number of Stores:' value={pharmacyData.findUniquePharmacy.store} />
            </Grid>
          }
        </AccordionDetails>
      </Accordion>
      {pharmacyWishlistItems.length > 0 && (
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography component="h1" variant="h5">Wishlist</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Paper>
              <TableContainer>
                <Table aria-label="wishlist table">
                  <TableHead sx={{backgroundColor: '#ededed'}}>
                    <TableRow>
                      <TableCell>User</TableCell>
                      <TableCell>NDC</TableCell>
                      <TableCell>Drug Name</TableCell>
                      <TableCell>Manufacturer</TableCell>
                      <TableCell>Dosage Form</TableCell>
                      <TableCell>Strength</TableCell>
                      <TableCell>Created</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pharmacyWishlistItems.map((item: any) => (
                      <TableRow
                        key={item.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell>{userById.get(item.buyerUserId) || `User #${item.buyerUserId}`}</TableCell>
                        <TableCell>{item.ndcNumber}</TableCell>
                        <TableCell>{item.drugName}</TableCell>
                        <TableCell>{item.manufacturer}</TableCell>
                        <TableCell>{item.dosageForm || 'N/A'}</TableCell>
                        <TableCell>{item.strength || 'N/A'}</TableCell>
                        <TableCell>{moment(item.createdAt).format('MM/DD/YYYY')}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </AccordionDetails>
        </Accordion>
      )}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h1" variant="h5">Physical Address</Typography>
          { editPhysicalAddress ?
            <EditOffOutlinedIcon
              sx={{ ml: 1, cursor: 'pointer', color: grey[500] }}
              onClick={(event: any) => {
                event.stopPropagation();
                setEditPhysicalAddress(false);
              }}
            />
            :
            <EditOutlinedIcon
              sx={{ ml: 1, cursor: 'pointer', color: green[500] }}
              onClick={(event) => {
                event.stopPropagation();
                setEditPhysicalAddress(true);
              }}
            />
          }
        </AccordionSummary>
        <AccordionDetails>
          { editPhysicalAddress?
            <PhysicalAddress
              data={pharmacyData.findUniquePharmacy.PharmacyAddress}
              states={pharmacyOptionData.findManyState}
              pharmacyId={Number(pharmacyId)}
              isAdminEdit={true}
              refetchPharmacy={refetch}
            />
            :
            <Grid container spacing={2}>
              <PharmacyDetailsItem label='Physical Address:' value={pharmacyData.findUniquePharmacy.PharmacyAddress[0].address} />
              <PharmacyDetailsItem label='City:' value={pharmacyData.findUniquePharmacy.PharmacyAddress[0].city} />
              <PharmacyDetailsItem label='State:' value={getOption(pharmacyOptionData.findManyState, pharmacyData.findUniquePharmacy.PharmacyAddress[0].State.id).label} />
              <PharmacyDetailsItem label='Zip Code:' value={pharmacyData.findUniquePharmacy.PharmacyAddress[0].zipCode} />
            </Grid>
          }
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h1" variant="h5">Business Information</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography paragraph={true} component="h1" variant="h6">Bank Account</Typography>
          { getBankAccount(pharmacyData.findUniquePharmacy.BankAccount)?.last4 && getBankAccount(pharmacyData.findUniquePharmacy.BankAccount)?.routingNumber ?
            <Grid container spacing={2}>
              <PharmacyDetailsItem label='Bank Account Name:' value={getBankAccount(pharmacyData.findUniquePharmacy.BankAccount).accountHolderName} />
              <PharmacyDetailsItem label='Routing Number:' value={getBankAccount(pharmacyData.findUniquePharmacy.BankAccount).routingNumber} />
              <PharmacyDetailsItem label='Account Number:' value={`****${getBankAccount(pharmacyData.findUniquePharmacy.BankAccount).last4}`} />
            </Grid>
            :
            <Typography component="h4" variant="subtitle2">No Data</Typography>
          }
          <Divider sx={{borderWidth: '1px', mt: 1, margin: '16px 0'}} />
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={pharmacyData.findUniquePharmacy.cardPaymentEnabled ?? false}
                  onChange={(e) => handleCardPaymentToggle(e.target.checked)}
                  disabled={cardToggleLoading}
                />
              }
              label="Enable Credit/Debit Card Payment"
            />
            {cardToggleLoading && <CircularProgress size={18} sx={{ ml: 1 }} />}
          </Box>
          {(() => {
            const achAccount = getBuyerAchAccount(
              pharmacyData.findUniquePharmacy.BankAccount
            );
            const cardAccount = getBuyerCardAccount(
              pharmacyData.findUniquePharmacy.BankAccount
            );
            const achStatusChip = getPaymentAccountStatusChip(achAccount?.status);
            const cardStatusChip = getPaymentAccountStatusChip(cardAccount?.status);
            const hasAnyPaymentMethod = Boolean(achAccount || cardAccount);

            return (
              <>
                <Typography component="h1" variant="h6" sx={{ mb: 2 }}>
                  Payment Accounts
                </Typography>
                {!hasAnyPaymentMethod ? (
                  <Typography component="h4" variant="subtitle2">
                    No Data
                  </Typography>
                ) : (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {achAccount && (
                      <Box>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            flexWrap: 'wrap',
                            mb: 2,
                          }}
                        >
                          <Chip
                            size="small"
                            icon={<AccountBalanceIcon />}
                            label="ACH"
                            color="info"
                            variant="filled"
                            sx={{
                              color: '#fff',
                              '& .MuiChip-label, & .MuiChip-icon': { color: '#fff' },
                            }}
                          />
                          {achStatusChip && (
                            <Chip
                              size="small"
                              label={achStatusChip.label}
                              color={achStatusChip.color}
                              variant="filled"
                            />
                          )}
                        </Box>
                        <Grid container spacing={2}>
                          <PharmacyDetailsItem
                            label="Bank Account Name:"
                            value={achAccount.accountHolderName}
                          />
                          <PharmacyDetailsItem
                            label="Routing Number:"
                            value={achAccount.routingNumber}
                          />
                          <PharmacyDetailsItem
                            label="Account Number:"
                            value={`****${achAccount.last4}`}
                          />
                        </Grid>
                      </Box>
                    )}
                    {cardAccount && (
                      <Box>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            flexWrap: 'wrap',
                            mb: 2,
                          }}
                        >
                          <Chip
                            size="small"
                            icon={<CreditCardIcon />}
                            label="Card"
                            color="primary"
                            variant="filled"
                            sx={{
                              color: '#fff',
                              '& .MuiChip-label, & .MuiChip-icon': { color: '#fff' },
                            }}
                          />
                          {cardStatusChip && (
                            <Chip
                              size="small"
                              label={cardStatusChip.label}
                              color={cardStatusChip.color}
                              variant="filled"
                            />
                          )}
                        </Box>
                        <Grid container spacing={2}>
                          <PharmacyDetailsItem
                            label="Card Brand:"
                            value={cardAccount.bankName || '—'}
                          />
                          <PharmacyDetailsItem
                            label="Name on Card:"
                            value={cardAccount.accountHolderName || '—'}
                          />
                          <PharmacyDetailsItem
                            label="Card Number:"
                            value={`****${cardAccount.last4}`}
                          />
                        </Grid>
                      </Box>
                    )}
                  </Box>
                )}
              </>
            );
          })()}
          <Divider sx={{borderWidth: '1px', mt: 1, margin: '16px 0'}} />
          <Grid container spacing={2}>
            {getPharmacyFiles(pharmacyData?.findUniquePharmacy?.PharmacyFiles, 'bank').map((pharmacyFile: any, index: number) => (
              <Grid item xs={12} key={index}>
                <Link href={`${SERVER_URL}/file/${pharmacyFile.File.key}`} color="inherit" target='_blank'>
                  147c (confirmation letter from IRS)
                </Link>
              </Grid>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h1" variant="h5">Other Details</Typography>
          { editOtherDetails ?
            <EditOffOutlinedIcon
              sx={{ ml: 1, cursor: 'pointer', color: grey[500] }}
              onClick={(event: any) => {
                event.stopPropagation();
                setEditOtherDetails(false);
              }}
            />
            :
            <EditOutlinedIcon
              sx={{ ml: 1, cursor: 'pointer', color: green[500] }}
              onClick={(event) => {
                event.stopPropagation();
                setEditOtherDetails(true);
              }}
            />
          }
        </AccordionSummary>
        <AccordionDetails>
          { editOtherDetails ?
            <OtherDetails
              data={pharmacyData.findUniquePharmacy.PharmacyDetail}
              pharmacyId={Number(pharmacyId)}
              pharmacyTypes={pharmacyOptionData.findManyPharmacyType}
              isAdminEdit={true}
              refetchPharmacy={refetch}
            />
            :
            <Grid container spacing={2}>
              <PharmacyDetailsItem label='Pharmacy Manager(Pic)/Contact Name:' value={pharmacyData.findUniquePharmacy.PharmacyDetail.managerContactName} />
              <PharmacyDetailsItem label='Contract Manager:' value={pharmacyData.findUniquePharmacy.PharmacyDetail.contractManager} />
              <PharmacyDetailsItem label='Pharmacy Type:' value={getOption(pharmacyOptionData.findManyPharmacyType, pharmacyData.findUniquePharmacy.PharmacyDetail.PharmacyDetailTypes[0].PharmacyType.id).label} />
              <PharmacyDetailsItem label='340B Status:' value={pharmacyData.findUniquePharmacy.PharmacyDetail.is340B ? 'YES' : 'NO'} />
            </Grid>
          }
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h1" variant="h5">Users</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Paper>
            <TableContainer>
              <Table aria-label="simple table">
                <TableHead sx={{backgroundColor: '#ededed'}}>
                  <TableRow>
                    <TableCell>User name</TableCell>
                    <TableCell>Role</TableCell>          
                    <TableCell>Email</TableCell>
                    <TableCell>Phone number</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pharmacyUsers.findManyPharmacyUsers.map((user: any, index: number) => (
                    <TableRow
                      key={`${user.id}-${index}`}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">{`${user.User.firstName} ${user.User.lastName}`}</TableCell>      
                      <TableCell>{index === 0 ? 'Owner' : 'Manager'}</TableCell>
                      <TableCell>{user.User.email}</TableCell>
                      <TableCell>{user.User.phone}</TableCell>
                      <TableCell align="center">
                        <Button
                          type="button"
                          onClick={() => resetPassword(user.User.id, `${user.User.firstName} ${user.User.lastName}`)}
                          variant='contained'
                          color='primary'
                          sx={{ width: '170px' }}
                        >
                          Reset Password
                          { resetLoading === user.User.id && <CircularProgress sx={{ml: 1}} size={14} color='inherit' />}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h1" variant="h5">Review Following Statements</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            {filteredStatements().map((statement: any)=> (
              <React.Fragment key={statement.id}>
                <Grid item xs={12} sm={12} md={11}>
                  <div dangerouslySetInnerHTML={{ __html: statement?.question }}></div>
                </Grid>
                <Grid item xs={12} sm={12} md={1} sx={{fontWeight: '600'}}>
                  {statement.answer}
                </Grid>
                <Grid item xs={12}>
                  <Divider sx={{borderWidth: '1px', mt: 1}} />
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
      {pharmacyData.findUniquePharmacy.AdditionalQuestions.length > 0 && (
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography component="h1" variant="h5">Additional Questions</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              {pharmacyData.findUniquePharmacy.AdditionalQuestions.map((additionalItem: any, index: number)=> (
                <React.Fragment key={additionalItem.id}>
                  <Grid item xs={12} sm={12} md={6}>
                    <div dangerouslySetInnerHTML={{ __html: additionalItem.question }}></div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} sx={{fontWeight: '600'}}>
                    {`${additionalQuestions[index].options.find((addQ: any) => addQ.key ===  additionalItem.answer)?.name} ${additionalItem.additionalAnswer}`}
                  </Grid>
                  <Grid item xs={12}>
                    <Divider sx={{borderWidth: '1px', mt: 1}} />
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}
      <Paper sx={{width: '100%', p: 4, display: 'flex'}}>
        <Grid container spacing={2}>
          {getPharmacyFiles(pharmacyData?.findUniquePharmacy?.PharmacyFiles).map((pharmacyFile: any) => (
            <Grid item xs={12} sm={12} md={6} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}} key={pharmacyFile.File.key}>
              <Button sx={{width: '250px'}} size='large' variant="contained">
                <Link href={`${SERVER_URL}/file/${pharmacyFile.File.key}`} color="inherit" target='_blank'>
                  {pharmacyFile.File.type === 'deaLicense' ? 'DEA License' : 'Pharmacy License'}
                </Link>
                {pharmacyFile.File.name.split('.')[1] === 'pdf' ? <PictureAsPdfOutlinedIcon sx={{ml: 1}} /> : <LocalSeeOutlinedIcon sx={{ml: 1}} />}
              </Button>
              <Grid sx={{mt: 2, textAlign: 'center', fontWeight: '600'}}>{pharmacyFile.File.name}</Grid>
            </Grid>
          ))}
        </Grid>
      </Paper>
      <Paper sx={{display: 'flex', flexDirection: 'column', mt: 2, pb: 2, mb: 4 }}>
        <Box component="form" onSubmit={handleSubmit(handleUpdatePharmacy)} noValidate>
          <Grid container sx={{ p: 2 }} spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  control={control}
                  name="deaLicenseDate"
                  defaultValue={pharmacyData.findUniquePharmacy.PharmacyLicenses.length > 0
                    ? dayjs(pharmacyData.findUniquePharmacy.PharmacyLicenses[pharmacyData.findUniquePharmacy.PharmacyLicenses?.length - 1]?.deaLicenseDate)
                    : ''
                  }
                  render={({
                    field: { onChange, value },
                  }) => (
                    <FormControl fullWidth>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          if (isLicenseExpired(date, getValues('ncpdpLicenseDate'))) {
                            const defaultStatus = statusData.findManyStatus.find((status: any) => status.key === 'EXPIRED');
                            setValue('status', defaultStatus.id);
                          } else {
                            setValue('status', pharmacyData.findUniquePharmacy.PharmacyStatus?.Status?.id);
                          }
                          onChange(date?.isValid ? date : "");
                        }}
                        format={"MM/DD/YYYY"}
                        label="DEA License Date"
                        slotProps={{
                          textField: {
                            error: !!errors.deaLicenseDate,
                            helperText: errors.deaLicenseDate?.message?.toString(),
                          },
                        }}
                      />
                    </FormControl>
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  control={control}
                  name="ncpdpLicenseDate"
                  defaultValue={pharmacyData.findUniquePharmacy.PharmacyLicenses.length > 0
                    ? dayjs(pharmacyData.findUniquePharmacy.PharmacyLicenses[pharmacyData.findUniquePharmacy.PharmacyLicenses?.length - 1]?.ncpdpLicenseDate)
                    : ''
                  }
                  render={({
                    field: { onChange, value },
                  }) => (
                    <FormControl fullWidth>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          if (isLicenseExpired(date, getValues('deaLicenseDate'))) {
                            const defaultStatus = statusData.findManyStatus.find((status: any) => status.key === 'EXPIRED');
                            setValue('status', defaultStatus.id);
                          } else {
                            setValue('status', pharmacyData.findUniquePharmacy.PharmacyStatus?.Status?.id);
                          }
                          onChange(date?.isValid ? date : "");
                        }}
                        format={"MM/DD/YYYY"}
                        label="Pharmacy License Date"
                        slotProps={{
                          textField: {
                            error: !!errors.ncpdpLicenseDate,
                            helperText: errors.ncpdpLicenseDate?.message?.toString(),
                          },
                        }}
                      />
                    </FormControl>
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Controller
                name="status"
                control={control}
                defaultValue={pharmacyData.findUniquePharmacy.PharmacyStatus?.Status?.id || null}
                render={({ field }) => (
                  <FormControl fullWidth>
                    <InputLabel id="status-label">Status</InputLabel>
                    <Select
                      {...field}
                      labelId="status-label"
                      id="pharmacyType"
                      label="Status"
                      required
                      {...register('status')}
                      error={!!errors.status}
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      {statusData.findManyStatus.map((pharmacyType: IPharmacyType) => (
                        <MenuItem key={pharmacyType.id} value={pharmacyType.id}>{pharmacyType.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />
            </Grid>
          </Grid>
          <Box sx={{ display: 'flex', justifyContent: 'space-around' , flexDirection: 'row' }}>
            <Button type="button" variant='contained' color='primary' sx={{width: '200px'}} onClick={() => navigate(routeConfigs.pharmacies.path)}>
              Cancel
            </Button>
            <Button type="submit" variant='contained' color='primary' sx={{width: '200px'}}>
              Save
              { loading && <CircularProgress sx={{ml: 1}} size={14} color='inherit' />}
            </Button>
          </Box>
        </Box>
      </Paper>
      <Paper sx={{display: 'flex', flexDirection: 'column', mt: 2, pb: 2, mb: 4 }}>
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography component="h1" variant="h5">Selling Limitations</Typography>
            <Chip
              size="small"
              label={isSellingLimitationsActive ? 'Active' : 'Inactive'}
              color={isSellingLimitationsActive ? 'success' : 'default'}
              variant={isSellingLimitationsActive ? 'filled' : 'outlined'}
            />
          </Box>
          <Typography component="p" variant="body2" sx={{ mt: 1, mb: 2 }}>
            Affects Selling capabilities of the pharmacy. Buying remains unaffected.
          </Typography>
          <Box
            sx={{
              mb: 2,
              p: 1.5,
              borderRadius: 1,
              border: '1px solid',
              borderColor: '#7f1d1d',
              backgroundColor: '#fee2e2',
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={sellingLimitationsBlockAll}
                  onChange={(event) => setSellingLimitationsBlockAll(event.target.checked)}
                  sx={{
                    color: '#7f1d1d',
                    '&.Mui-checked': {
                      color: '#7f1d1d',
                    },
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ color: '#7f1d1d', fontWeight: 700 }}>
                  Limit Selling - Warning! Blocks all postings for this pharmacy
                </Typography>
              }
            />
          </Box>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                <Button
                  type="button"
                  variant="outlined"
                  size="small"
                  onClick={handleAddLegacyGlp1Ndcs}
                >
                  Add GLP-1 limitation
                </Button>
              </Box>
              <Autocomplete
                multiple
                options={ndcSearchOptions}
                value={sellingLimitedNdcs}
                onChange={(_, value: any[]) => setSellingLimitedNdcs(value)}
                getOptionLabel={(option: any) => option?.label || option?.ndc || ''}
                isOptionEqualToValue={(option: any, value: any) =>
                  normalizeNdc(option.ndc) === normalizeNdc(value.ndc)
                }
                filterOptions={(options) => options}
                onInputChange={(_, value) => {
                  debouncedSellingLimitationNdcSearch(value);
                }}
                loading={sellingLimitationSearchLoading}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Restricted NDCs"
                    placeholder="Type at least 3 characters"
                    helperText="Only these exact NDCs will be blocked from posting."
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                multiple
                options={manufacturerSearchOptions}
                value={sellingLimitedManufacturers}
                onChange={(_, value: any[]) => setSellingLimitedManufacturers(value)}
                getOptionLabel={(option: any) => option?.label || option?.manufacturer || ''}
                isOptionEqualToValue={(option: any, value: any) =>
                  normalizeManufacturer(option.manufacturer) === normalizeManufacturer(value.manufacturer)
                }
                filterOptions={(options) => options}
                onInputChange={(_, value) => {
                  debouncedSellingLimitationManufacturerSearch(value);
                }}
                loading={sellingLimitationSearchLoading}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Restricted manufacturers (all NDCs under labeler)"
                    placeholder="Type at least 3 characters"
                    helperText="Selecting a manufacturer blocks and inactivates  posting for all NDCs under that labeler."
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="button"
                variant='contained'
                color='primary'
                sx={{width: '260px'}}
                onClick={handleRequestSaveSellingLimitations}
                disabled={sellingLimitationsSaving}
              >
                Save Selling Limitations
                {sellingLimitationsSaving && <CircularProgress sx={{ml: 1}} size={14} color='inherit' />}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <Paper sx={{display: 'flex', flexDirection: 'column', mt: 2, pb: 2, mb: 4 }}>
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography component="h1" variant="h5">Buying Limitations</Typography>
            <Chip
              size="small"
              label={isBuyingLimitationsActive ? 'Active' : 'Inactive'}
              color={isBuyingLimitationsActive ? 'success' : 'default'}
              variant={isBuyingLimitationsActive ? 'filled' : 'outlined'}
            />
          </Box>
          <Typography component="p" variant="body2" sx={{ mt: 1, mb: 2 }}>
            Affects Buying capabilities of the pharmacy. When one or more seller pharmacies are selected,
            this pharmacy will only see Buy section items posted by those pharmacies. Selling remains unaffected.
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Autocomplete
                multiple
                options={buyingAllowedSellerOptions}
                value={buyingAllowedSellers}
                onChange={(_, value: any[]) => setBuyingAllowedSellers(value)}
                getOptionLabel={(option: any) => {
                  const legalName = option?.legalName || '';
                  const email = option?.email || '';
                  if (legalName && email) {
                    return `${legalName} (${email})`;
                  }
                  return legalName || email || '';
                }}
                isOptionEqualToValue={(option: any, value: any) =>
                  Number(option.id) === Number(value.id)
                }
                filterOptions={(options, { inputValue }) => {
                  const term = inputValue.trim().toLowerCase();
                  if (!term) {
                    return options;
                  }
                  return options.filter((option: any) => {
                    const legalName = (option?.legalName || '').toLowerCase();
                    const email = (option?.email || '').toLowerCase();
                    return legalName.includes(term) || email.includes(term);
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Allowed seller pharmacies"
                    placeholder="Search by legal name or email"
                    helperText="The Buy section will only show items from the selected pharmacies. Leave empty for no limitation."
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="button"
                variant='contained'
                color='primary'
                sx={{width: '260px'}}
                onClick={handleSaveBuyingLimitations}
                disabled={buyingLimitationsSaving}
              >
                Save Buying Limitations
                {buyingLimitationsSaving && <CircularProgress sx={{ml: 1}} size={14} color='inherit' />}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <Dialog
        open={confirmSellingLimitationsOpen}
        onClose={handleCancelSaveSellingLimitations}
        aria-labelledby="selling-limitations-confirm-title"
        aria-describedby="selling-limitations-confirm-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="selling-limitations-confirm-title">
          Apply Selling Limitations?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="selling-limitations-confirm-description">
            Are you sure you want to apply these limitations? This can affect active postings for this pharmacy (matching listings may be deactivated).
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={handleConfirmSaveSellingLimitations} color="primary" variant="contained" autoFocus>
            Yes
          </Button>
          <Button onClick={handleCancelSaveSellingLimitations} color="inherit" variant="outlined">
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmCardDisableOpen}
        onClose={() => setConfirmCardDisableOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Disable Card Payment?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to disable card payment for this pharmacy? The attached card will be removed.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={confirmDisableCardPayment} color="error" variant="contained" autoFocus>
            Yes, Disable
          </Button>
          <Button onClick={() => setConfirmCardDisableOpen(false)} color="inherit" variant="outlined">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      {openResetPassword && (
        <Dialog
          fullWidth
          maxWidth='sm'
          open={Boolean(openResetPassword)}
          onClose={() => setResetPassword(null)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {`Temporary Password for ${openResetPassword.userName}`} 
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {openResetPassword.password}
              <ContentCopyIcon
                onClick={(event: any) => {
                  event.stopPropagation();
                  navigator.clipboard.writeText(openResetPassword.password);
                  addToast({ type: NotificationType.Success, title: 'Copied to Clipboard' });
                }}
                fontSize='small'
                sx={{ml: 1, cursor: 'pointer'}}
              />
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}

export default Pharmacy;